import { Box, Paper, Stack, Typography } from '@mui/material';
import React, { type ReactNode } from 'react';

interface SectionCardProps {
    title: string;
    /** Right-aligned header controls (CTA, status chip). */
    actions?: ReactNode;
    children: ReactNode;
}

/** Outlined section with a title row and optional right-aligned actions. */
export const SectionCard: React.FC<SectionCardProps> = ({ title, actions, children }) => (
    <Paper
        variant="outlined"
        sx={{ borderRadius: 3, p: { xs: 2, sm: 3 }, borderColor: 'rgba(148, 163, 184, 0.24)' }}
    >
        <Stack
            direction={{ xs: 'column', sm: 'row' }}
            spacing={1.5}
            sx={{
                justifyContent: 'space-between',
                alignItems: { xs: 'stretch', sm: 'flex-start' },
                mb: 2,
            }}
        >
            <Box sx={{ minWidth: 0 }}>
                <Typography variant="h6" sx={{ fontWeight: 700, lineHeight: 1.3 }}>
                    {title}
                </Typography>
            </Box>
            {actions ? (
                <Stack
                    direction="row"
                    spacing={1}
                    useFlexGap
                    sx={{ flexShrink: 0, alignItems: 'center', flexWrap: 'wrap' }}
                >
                    {actions}
                </Stack>
            ) : null}
        </Stack>
        {children}
    </Paper>
);
